import React from "react";
import PropTypes from "prop-types";
import OrganizationView from "features/organization/components/OrganizationView";

export default class RequireOrganization extends React.Component {
  static propTypes = {
    organization: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]).isRequired
  };

  static defaultProps = {
    organization: undefined
  };

  render() {
    if (this.props.organization) return <div>{this.props.children}</div>;
    return <OrganizationView {...this.props} />;
  }
}
